import type { ReactNode, ErrorInfo } from "react";
import { Component } from "react";
import { logger } from "../../logger";
import { datadogRum } from "@datadog/browser-rum";

interface ErrorBoundaryState {
  hasError: boolean;
}

interface ErrorBoundaryProps {
  children: ReactNode;
}

export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    datadogRum.addError(error, { errorInfo });
    // Log error to Datadog
    logger.error("Error caught by ErrorBoundary", {
      error,
      errorInfo
    });
  }

  render(): ReactNode {
    if (this.state.hasError)
      return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>An unexpected error has occurred</h1>
          <p>Our team has been notified and is working on a fix.</p>
        </div>
      );

    return this.props.children;
  }
}
